import React, { useState } from "react";
import { useProductData } from "@/zustand/productStore";
import { useCartData } from "@/zustand/cartStore";
import TagIcon from "@/utils/images/tagIcon";
import RemoveIcon from "@/utils/images/RemoveIcon";
import s from "@/components/Inputs/DiscountInput.module.scss";

const DiscountInput = ({ marginTop }) => {
  const { handleSetDiscountCode, handleRemoveDiscountCode, discountCode } = useCartData();
  const productData = useProductData();
  const [codeValue, setCodeValue] = useState("");
  const [error, setError] = useState("");
  const discountSettings = productData.discount_codes;
  const base = window?.post_template?.checkout_v6_summary;

  const handleDiscountApply = () => {
    if (codeValue.toUpperCase() === discountSettings.discount_code.toUpperCase()) {
      if (discountSettings.code_has_expiration_date && discountSettings.discount_code_expiration_date) {
        const [day, month, year] = discountSettings.discount_code_expiration_date.split("/");
        const expirationDate = new Date(year, month - 1, day);
        expirationDate.setHours(23, 59, 59, 999);
        const currentDate = new Date();

        if (currentDate > expirationDate) {
          setError(base?.tr_checkout_v6_discount_expired);
          return;
        }
      }
      handleSetDiscountCode(codeValue);
      setError("");
    } else {
      setError(base?.tr_checkout_v6_discount_error);
    }
    setCodeValue("");
  };

  const handleRemoveDiscount = () => {
    handleRemoveDiscountCode();
    setCodeValue("");
    setError("");
  };

  return (
    <>
      {discountSettings && (
        <>
          <div className={s.discount__inputContainer} style={{ marginTop: marginTop ?? "" }}>
            <div className={`${s["discount__inputContainer--input"]}`}>
              <input
                className={s["discount__inputContainer--styledInput"]}
                value={codeValue}
                onChange={(e) => setCodeValue(e.target.value)}
                placeholder={base?.tr_checkout_v6_discount_placeholder}
              />
            </div>
            <button
              type="button"
              className={s["discount__inputContainer--applyButton"]}
              onClick={() => {
                codeValue && handleDiscountApply();
              }}
            >
              <span className={s.text}>{base?.tr_checkout_v6_discount_apply}</span>
            </button>
          </div>
          {error && (
            <div className={s.discount__error} style={discountCode ? { marginBottom: "8px" } : {}}>
              {error}
            </div>
          )}
          <div className={s["discount__pill--container"]}>
            {discountCode && (
              <div className={s.discount__pill}>
                <TagIcon className={s["discount__pill--tag"]} />
                <span className={s["discount__pill--text"]}>{discountCode}</span>
                <div className={s["discount__pill--closeBtn"]} onClick={handleRemoveDiscount}>
                  <RemoveIcon />
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default DiscountInput;
